import { format } from 'date-fns';
import { Transaction } from '../types/transactions';
import { toCsv } from './csvSafe';

export const exportToCSV = (transactions: Transaction[], filename: string = 'transactions') => {
  // Define CSV headers
  const headers = [
    'Transaction ID',
    'Type',
    'Status',
    'Amount',
    'Adjusted Amount',
    'Amount in NGN',
    'Amount in USD',
    'Total in Crypto',
    'Coin',
    'TX ID',
    'User Name',
    'User Email',
    'Note',
    'Comment',
    'Withdrawal Type',
    'Source Collection',
    'Created At',
    'Updated At'
  ];

  // Convert transactions to CSV rows
  const csvRows = transactions.map(transaction => [
    transaction._id,
    transaction.type.replace('_', ' '),
    transaction.status.replace('_', ' '),
    transaction.amount.toFixed(2),
    transaction.adjustedAmount?.toFixed(2) || '',
    transaction.amountInNGN?.toFixed(2) || '',
    transaction.amountInUsd?.toFixed(2) || '',
    transaction.totalInCrypto?.toFixed(8) || '',
    transaction.coin || '',
    transaction.txId || '',
    transaction.user.name,
    transaction.user.email,
    transaction.note || '',
    transaction.comment || '',
    transaction.withdrawalType || '',
    transaction.sourceCollection || '',
    format(new Date(transaction.createdAt), 'yyyy-MM-dd HH:mm:ss'),
    transaction.updatedAt ? format(new Date(transaction.updatedAt), 'yyyy-MM-dd HH:mm:ss') : ''
  ]);

  // Combine headers and rows — formula-safe, RFC-quoted cells (spec 2026-11-03 §4.3);
  // the old join never doubled inner quotes.
  const csvContent = toCsv(headers, csvRows);

  // Create and download the file
  const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
  const link = document.createElement('a');
  const url = URL.createObjectURL(blob);
  link.setAttribute('href', url);
  link.setAttribute('download', `${filename}-${new Date().toISOString().split('T')[0]}.csv`);
  link.style.visibility = 'hidden';
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
}; 